// Mirrors Finkit.Permissions.User.FinkitUserPagesPermissions.Providers
// (GroupName = "User").
export const ProviderPermissions = {
  view: 'User.Providers.View',
  create: 'User.Providers.Create',
  update: 'User.Providers.Update',
  delete: 'User.Providers.Delete',
  manageAccount: 'User.Providers.ManageAccount',
} as const;
